export enum Todo {
  CHANGE,
  EXTEND,
  REPLACE
}
